import React from 'react';
import {
  Body,
  Divider,
  Grid,
  Heading
} from '@walmart-web/livingdesign-components';
import { Trans, useTranslation } from 'react-i18next';

import styles from './styles.module.css';

type Data = {
  title: string;
  content: string;
};

const HowDoesItWorkResources = () => {
  const { t } = useTranslation('ihut');

  const DATA = t('howDoesItWork.questions', { returnObjects: true }) as Data[];

  const renderContent = (index: number) => {
    return (
      <Body size="medium">
        <Trans
          i18nKey={`howDoesItWork.questions.${index}.content`}
          ns="ihut"
          components={{
            1: (
              <a
                href="/surveytaker/consent/products"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                here
              </a>
            )
          }}
        />
      </Body>
    );
  };

  return (
    <Grid className={styles.container}>
      <Heading size="small">{t('howDoesItWork.heading')}</Heading>
      {DATA.map(({ title }, index) => (
        <Grid key={index} className={styles.item}>
          <Body size="large" weight={700}>
            {title}
          </Body>
          {renderContent(index)}
          <Divider />
        </Grid>
      ))}
    </Grid>
  );
};

export default HowDoesItWorkResources;
